/* Core & libraries */
import React, {useState, useEffect} from "react";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
/* Styles */

/**
 *
 * @param {Array<string> | string} breakpointsList
 * @returns {boolean}
 */
export const useIsResponsive = (...breakpointsList) => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return !!breakpointsList.find((breakpoints) => {
    const [breakpointDown, breakpointUp] = Array.isArray(breakpoints) ? breakpoints : [breakpoints];
    if (breakpointUp) {
      return breakpointDown <= width && width <= breakpointUp;
    }

    return width <= breakpointDown;
  });
}

